module.exports = __webpack_public_path__ + "img/010-linkedin.1605cd36.png";